import {Component, Input, OnInit} from '@angular/core';
import {HttpResponse, HttpErrorResponse, HttpEventType, HttpEvent} from '@angular/common/http';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs';
import {FileObject, IFileObject} from '../../shared/model/file-object.model';
import {FileObjectService} from './file-object.service';
// import {MeetingService} from '../meeting/meeting.service';
// import {IMeeting} from '../../shared/model/meeting.model';
import {NgbActiveModal, NgbModal, NgbPanelChangeEvent, NgbRatingConfig} from '@ng-bootstrap/ng-bootstrap';
import {NgxSpinnerService} from 'ngx-spinner';
import {AccountService} from '../../singelton/account.service';
import {ToastrService} from 'ngx-toastr';
import {FileUploadService} from './file-upload-service';
import {JhiDataUtils} from 'ng-jhipster';
import {Customer} from "../../shared/model/customer.model";
import {CustomerFile} from "../../shared/model/customer-file.model";
import {FileDeleteDialogComponent} from "./file-delete-dialog.component";
import {FileShareSendComponent} from "./file-share-send.component";
import * as moment from 'jalali-moment';

@Component({
  selector: 'app-file-object-list-project',
  templateUrl: './file-object-list-project.component.html',
  styles: [`
    .star {
      font-size: 1.5rem;
      color: #b0c4de;
    }

    .filled {
      color: #1e90ff;
    }

    .bad {
      color: #deb0b0;
    }

    .filled.bad {
      color: #ff1e1e;
    }

    .star .fas {
      font-size: 17px !important;
    }
  `]

})

export class FileObjectListProjectComponent implements OnInit {
  // @Input() doctor_id;
  @Input() file_id;
  @Input() title;
  @Input() action;
  @Input() role;
  // @Input() customerId;
  @Input() projectId;
  @Input() factorId;
  @Input() contractId;
  @Input() orderId;
  @Input() salesCycleId;
  @Input() transactionId;
  @Input() token;


  isSaving: boolean;
  fileObjects: IFileObject[] = [];
  showAddParam: boolean;
  param1: any;
  file: IFileObject = new CustomerFile();

  error: any;
  success: any;
  links: any;
  totalItems: any;
  itemsPerPage: any;
  page: any = 0;
  predicate: any;
  previousPage: any;
  reverse: any;
  sortList: any;
  readonly = true;
  selected = 0;
  hovered = 0;

  form: FormGroup;
  progress = 0;

  beforeChange($event: NgbPanelChangeEvent) {
    if ($event.panelId === 'preventchange-2') {
      $event.preventDefault();
    }

    if ($event.panelId === 'preventchange-3' && $event.nextState === false) {
      $event.preventDefault();
    }
  }

  constructor(
    protected dataUtils: JhiDataUtils,
    // protected jhiAlertService: JhiAlertService,
    private activeModal: NgbActiveModal,
    protected fileObjectService: FileObjectService,
    protected activatedRoute: ActivatedRoute,
    // public meetingService: MeetingService,
    private modalService: NgbModal,
    // private doctorService: DoctorService,
    private fb: FormBuilder,
    private toastr: ToastrService
    , private spinner: NgxSpinnerService,
    public accountService: AccountService
    ,
    config: NgbRatingConfig,
    public fileUploadService: FileUploadService
  ) {
    this.form = this.fb.group({
      name: [''],
      avatar: [null]
    });

  }

  ngOnInit() {
    this.isSaving = false;
    this.loadAllFiles();
  }



  deleteFile(data: any) {
    const modalRef = this.modalService.open(FileDeleteDialogComponent, {windowClass: 'lg', backdrop: 'static'});
    modalRef.componentInstance.action = 'delete';
    modalRef.componentInstance.fileId = data;
    modalRef.componentInstance.fileEdit = data;

    modalRef.result.then(
      res => {
        this.loadAllFiles();
      },
      rejected => {
        this.loadAllFiles();
      }
    );
  }

  sendToCustomer(fileObject: IFileObject) {
    const modalRef = this.modalService.open(FileShareSendComponent, {windowClass: 'sm', backdrop: 'static'});
    modalRef.componentInstance.fileObject = fileObject;
    modalRef.result.then(
      () => {},
      () => {}
    );
  }

  numberWithCommas(x) {
    if (x) {
      x = x.toString();
      const pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(x)) {
        x = x.replace(pattern, '$1,$2');
      }
      return x;
    }
  }

  loadAllFiles() {
    this.spinner.show();
    if(this.projectId) {
      this.fileObjectService.findWithProjectId({
        page: 0,
        size: 20
      }, this.projectId).subscribe(
        (res: HttpResponse<IFileObject[]>) => this.onSuccessFiles(res.body, res.headers),
        (res2: HttpResponse<any>) => this.onError(res2.body)
      );
    } else if(this.factorId) {
      this.fileObjectService.findWithFactorId({
        page: 0,
        size: 20
      }, this.factorId).subscribe(
        (res: HttpResponse<IFileObject[]>) => this.onSuccessFiles(res.body, res.headers),
        (res2: HttpResponse<any>) => this.onError(res2.body)
      );
    } else if(this.transactionId) {
      this.fileObjectService.findWithTransactionId({
        page: 0,
        size: 20
      }, this.transactionId).subscribe(
        (res: HttpResponse<IFileObject[]>) => this.onSuccessFiles(res.body, res.headers),
        (res2: HttpResponse<any>) => this.onError(res2.body)
      );
    } else if(this.orderId) {
      this.fileObjectService.findWithOrderId({
        page: 0,
        size: 20
      }, this.orderId).subscribe(
        (res: HttpResponse<IFileObject[]>) => this.onSuccessFiles(res.body, res.headers),
        (res2: HttpResponse<any>) => this.onError(res2.body)
      );
    } else if(this.contractId) {
      this.fileObjectService.findWithContractId({
        page: 0,
        size: 20
      }, this.contractId).subscribe(
        (res: HttpResponse<IFileObject[]>) => this.onSuccessFiles(res.body, res.headers),
        (res2: HttpResponse<any>) => this.onError(res2.body)
      );
    } else if(this.salesCycleId) {
      this.fileObjectService.findWithSalesCycleId({
        page: 0,
        size: 20
      }, this.salesCycleId).subscribe(
        (res: HttpResponse<IFileObject[]>) => this.onSuccessFiles(res.body, res.headers),
        (res2: HttpResponse<any>) => this.onError(res2.body)
      );
    }


  }

  private onSuccessFiles(data, headers) {
    this.fileObjects = data;
    this.totalItems = headers.get('X-Total-Count');
    this.spinner.hide();

  }

  downloadFile(id) {

    this.fileObjectService.find(id).subscribe((res: HttpResponse<IFileObject>) => {
        this.file = res.body;
        const tabWindowId = window.open('about:blank', '_blank');
        tabWindowId.location.href = this.file.amazonLink;
      },
      (res: HttpErrorResponse) => console.log('______ error ______')
    );
  }

  clear() {
    this.activeModal.dismiss('save');
  }


  protected onSaveErrorFile() {
    this.isSaving = false;
  }

  protected onError(errorMessage: string) {
  }



  parseDateJalali(value) {
    let jalaliDate5 = '-';
    if (value) {
      jalaliDate5 = moment(new Date(value)).locale('fa').format('jYYYY/jM/jD');
    }
    return jalaliDate5;
  }

}
